<style lang="scss" scoped>
.header--network-status {
  padding: 0 10px;
  cursor: default;

  &:hover {
    background-color: unset;
  }

  > svg {
    // margin-top: 1em;
    vertical-align: middle;
  }

  > span {
    margin-left: 0.5em;
    font-size: 13px;
  }
}
</style>

<template lang="html">
  <el-tooltip effect="dark" :content="tooltip" placement="bottom-end">
    <label v-show="networkDelay" class="header--network-status">
      <svg
        viewBox="0 0 24 24"
        width="1.4em"
        height="1.4em"
        stroke-width="2"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M1.42 9a16 16 0 0 1 21.16 0"
          :stroke="networkDelay <= level[0] ? strokeColor : '#ddd'"
        />
        <path
          d="M5 12.55a11 11 0 0 1 14.08 0"
          :stroke="networkDelay <= level[1] ? strokeColor : '#ddd'"
        />
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" :stroke="strokeColor" />
        <line x1="12" y1="20" x2="12.01" y2="20" :stroke="strokeColor" />
      </svg>
      <span :style="{ color: strokeColor }">{{ display }}</span>
    </label>
  </el-tooltip>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import dayjs from 'dayjs'
import axios from 'axios'
import _slice from 'lodash/slice'
var timer = null
var pingAliyun = null
export default {
  name: 'HeaderNetworkStatus',
  computed: {
    ...mapGetters(['networkDelay']),
    strokeColor() {
      if (this.networkDelay <= this.level[0]) {
        return 'green'
      } else if (this.networkDelay <= this.level[1]) {
        return '#FB5C21'
      } else {
        return 'red'
      }
    },
    tooltip() {
      if (this.networkDelay <= this.level[0]) {
        return '网络良好'
      } else if (this.networkDelay <= this.level[1]) {
        return '网络一般'
      } else {
        return '网络较差'
      }
    },
    display() {
      if (this.networkDelay >= 1000) {
        return `${((this.networkDelay / 1000) % 60).toFixed(2)}s`
      }
      return `${this.networkDelay}ms`
    }
  },
  data() {
    return {
      level: [120, 250, 350]
    }
  },
  created() {
    const _this = this
    // 定时清理网络监测数组
    timer = setInterval(() => {
      const record = _this.$store.state.network.networkDelay
      if (record.length > 100) {
        // 取最后2条
        _this.resetNetworkDelay(_slice(record, record.length - 100))
      }
    }, 5 * 1000)
  },
  mounted() {
    const _this = this

    // 定时ping阿里云
    pingAliyun = setInterval(() => {
      var s = dayjs()
      axios
        .get('//assets.myjiedian.com/admin/ping.txt', {
          baseURL: '',
          params: { _: Date.now() }
        })
        .then(() => {
          // 记录网络用时
          const d = dayjs().diff(s, 'ms')
          // console.log(d)
          _this.recordNetworkDelay({
            target:
              window.location.protocol +
              '//assets.myjiedian.com/admin/ping.txt',
            delay: Math.ceil(d / 2) // 存在 OPTIONS + GET 跨域 所以为2个请求叠加
          })
        })
    }, 7 * 1000)
  },
  beforeDestroy() {
    clearInterval(timer)
    clearInterval(pingAliyun)
  },
  methods: {
    ...mapActions(['recordNetworkDelay', 'resetNetworkDelay'])
  }
}
</script>
